import { defineStore } from 'pinia'

interface DropdownInterface {
  dropdowns: { [index: string]: boolean }
}

export const useDropdownStore = defineStore('dropdown', {
  state: (): DropdownInterface => {
    return {
      dropdowns: {
        header_account: false,
        header_cart: false,
      },
    }
  },
  actions: {
    open(dropdownName: string) {
      for (const dropdown in this.dropdowns) {
        this.dropdowns[dropdown] = dropdownName === dropdown
      }
    },
  },
})
